// extracted by mini-css-extract-plugin
module.exports = {"Divider":"Divider_Divider__2SSkV","DividerIcon":"Divider_DividerIcon__3zC35"};